var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavigationAndActionColumnSelection(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.04 5.5c.592.001 1.22.514 1.22 1.128l.234 9.373a17.924 17.924 0 0 1 2.389-.146c.48 0 .982.015 1.499.047a22.52 22.52 0 0 1 4.198.688c1.207.413 2.14 1.516 2.291 2.915.009.078.012.166.015.242L32 25.483c0 .343-.062.674-.146.991a6.934 6.934 0 0 1-2.263 3.963A6.303 6.303 0 0 1 25.405 32a6.861 6.861 0 0 1-4.926-2.115L10.43 19.552a1.965 1.965 0 0 1 1.456-.633c.636 0 1.295.278 1.868.707l4.241 3.243v-.17l.723-16.07c0-.615.731-1.128 1.322-1.129zM7.958 0v21H0V0h7.958zm9.998.001v4.251c-.705.544-1.217 1.347-1.237 2.317l-.557 12.38-1.192-.912c-.987-.738-2.047-1.12-3.084-1.12-.682 0-1.313.182-1.888.497V0h7.958zm9.997 0v14.195a24.267 24.267 0 0 0-2.447-.29 27.103 27.103 0 0 0-2.066-.048l-.18-7.28c-.002-1.644-1.475-3.076-3.217-3.078-.019 0-.033.004-.048.004V0h7.958z",
    fill: "#262626",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationAndActionColumnSelection);
export default __webpack_public_path__ + "static/media/navigation-and-action-column-selection.e928b9e5.svg";
export { ForwardRef as ReactComponent };